var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext, useEffect, useState } from 'react';
import WindowStateContext from '../context/window-state-context';
import useOnBlur from './useOnBlur';
import useOnChange from './useOnChange';
export default function useFormItem(itemId, options) {
    if (options === void 0) { options = {}; }
    var _a = useState(''), value = _a[0], setValue = _a[1];
    var stateFromEnv = useContext(WindowStateContext);
    var _b = options.extractor, extractor = _b === void 0 ? function (evt) { return evt.target.value; } : _b;
    var onChange = useOnChange(itemId, setValue, __assign(__assign({}, options), { extractor: extractor })).onChange;
    var onBlur = useOnBlur(itemId, __assign(__assign({}, options), { extractor: extractor })).onBlur;
    var valuesFromEnv = stateFromEnv.fields;
    useEffect(function () {
        if (valuesFromEnv && valuesFromEnv[itemId]) {
            setValue(valuesFromEnv[itemId]);
        }
        else {
            setValue('');
        }
    }, [valuesFromEnv]);
    return { value: value, id: itemId, onChange: onChange, onBlur: onBlur };
}
//# sourceMappingURL=useFormItem.js.map